"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
const dynamicSort = property => {
  let sortOrder = 1;
  if (property[0] === "-") {
    sortOrder = -1;
    property = property.substr(1);
  }
  return function (a, b) {
    let result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
    return result * sortOrder;
  };
};
const hobbies = () => {
  return [{
    id: "travel",
    icon: "🧳",
    title: "🧳 viajar",
    title_en: "🧳 travel",
    label: "viajar",
    label_en: "travel",
    backgroundColor: "#FFF6E5"
  }, {
    id: "movies",
    icon: "🎬",
    title: "🎬 cine",
    title_en: "🎬 movies",
    label: "cine",
    label_en: "movies",
    backgroundColor: "#ECF4FB"
  }, {
    id: "theatre",
    icon: "🎭",
    title: "🎭 teatro",
    title_en: "🎭 theatre",
    label: "teatro",
    label_en: "theatre",
    backgroundColor: "#FFE5E5"
  }, {
    id: "tech",
    icon: "📱",
    title: "📱 tecnología",
    title_en: "📱 tech",
    label: "tecnología",
    label_en: "tech",
    backgroundColor: "#F0F3F6"
  }, {
    id: "friends",
    icon: "🍻",
    title: "🍻 amigos",
    title_en: "🍻 friends",
    label: "amigos",
    label_en: "friends",
    backgroundColor: "#FFF6E5"
  }, {
    id: "sports",
    icon: "⚽️",
    title: "⚽️ deportes",
    title_en: "⚽️ sports",
    label: "deportes",
    label_en: "sports",
    backgroundColor: "#ECF4FB"
  }, {
    id: "art",
    icon: "🎨",
    title: "🎨 arte",
    title_en: "🎨 art",
    label: "arte",
    label_en: "art",
    backgroundColor: "#FFE5E5"
  }, {
    id: "cooking",
    icon: "⏲️",
    title: "⏲️ cocinar",
    title_en: "⏲️ cook",
    label: "cocinar",
    label_en: "cook",
    backgroundColor: "#FFF6E5"
  }, {
    id: "food",
    icon: "🍽️",
    title: "🍽️ comida",
    title_en: "🍽️ food",
    label: "comida",
    label_en: "food",
    backgroundColor: "#F0F3F6"
  }, {
    id: "sing",
    icon: "🎤",
    title: "🎤 cantar",
    title_en: "🎤 sing",
    label: "cantar",
    label_en: "sing",
    backgroundColor: "#ECF4FB"
  }, {
    id: "walk",
    icon: "👟",
    title: "👟 pasear",
    title_en: "👟 walk",
    label: "pasear",
    label_en: "walk",
    backgroundColor: "#F9F6F3"
  }, {
    id: "games",
    icon: "♟️",
    title: "♟️ juegos",
    title_en: "♟️ games",
    label: "juegos",
    label_en: "games",
    backgroundColor: "#F0F3F6"
  }, {
    id: "fashion",
    icon: "👗",
    title: "👗 moda",
    title_en: "👗 fashion",
    label: "moda",
    label_en: "fashion",
    backgroundColor: "#ECF4FB"
  }, {
    id: "cars",
    icon: "🚗",
    title: "🚗 coches",
    title_en: "🚗 cars",
    label: "coches",
    label_en: "cars",
    backgroundColor: "#FFE5E5"
  }, {
    id: "series",
    icon: "📺",
    title: "📺 series",
    title_en: "📺 series",
    label: "series",
    label_en: "series",
    backgroundColor: "#F0F3F6"
  }, {
    id: "dance",
    icon: "💃",
    title: "💃 bailar",
    title_en: "💃 dance",
    label: "bailar",
    label_en: "dance",
    backgroundColor: "#FFE5E5"
  }, {
    id: "music",
    icon: "🎶",
    title: "🎶 música",
    title_en: "🎶 music",
    label: "música",
    label_en: "music",
    backgroundColor: "#F0F3F6"
  }, {
    id: "write",
    icon: "✍",
    title: "✍ escribir",
    title_en: "✍ write",
    label: "escribir",
    label_en: "write",
    backgroundColor: "#F9F6F3"
  }, {
    id: "crafts",
    icon: "✂️",
    title: "✂️ manualidades",
    title_en: "✂️ crafts",
    label: "manualidades",
    label_en: "crafts",
    backgroundColor: "#FFE5E5"
  }, {
    id: "animals",
    icon: "🐶",
    title: "🐶 animales",
    title_en: "🐶 animals",
    label: "animales",
    label_en: "animals",
    backgroundColor: "#F9F6F3"
  }, {
    id: "nature",
    icon: "🌿",
    title: "🌿 naturaleza",
    title_en: "🌿 nature",
    label: "naturaleza",
    label_en: "nature",
    backgroundColor: "#E4F8EE"
  }, {
    id: "knitt",
    icon: "🧵",
    title: "🧵 costura",
    title_en: "🧵 knitt",
    label: "costura",
    label_en: "knitt",
    backgroundColor: "#ECF4FB"
  }, {
    id: "talk",
    icon: "💬",
    title: "💬 charlar",
    title_en: "💬 talk",
    label: "charlar",
    label_en: "talk",
    backgroundColor: "#F0F3F6"
  }, {
    id: "yoga",
    icon: "🧘",
    title: "🧘 yoga",
    title_en: "🧘 yoga",
    label: "yoga",
    label_en: "yoga",
    backgroundColor: "#F0F3F6"
  }, {
    id: "read",
    icon: "📚",
    title: "📚 leer",
    title_en: "📚 read",
    label: "leer",
    label_en: "read",
    backgroundColor: "#ECF4FB"
  }].sort(dynamicSort("title"));
};
const findHobbies = (idHobbie, locale) => {
  const item = hobbies().find(element => element.id === idHobbie);
  if (!item) {
    return null;
  }
  const isEnglish = locale === "en";
  return {
    id: item.id,
    icon: item.icon,
    title: isEnglish ? item.title_en : item.title,
    label: isEnglish ? item.label_en : item.label,
    backgroundColor: item.backgroundColor
  };
};
const schedule = () => {
  return {
    hours: [{
      id: "morning",
      title: "mañana"
    }, {
      id: "afternoon",
      title: "tarde"
    }],
    days: [{
      id: "monday",
      title: "lunes"
    }, {
      id: "tuesday",
      title: "martes"
    }, {
      id: "wednesday",
      title: "miércoles"
    }, {
      id: "thursday",
      title: "jueves"
    }, {
      id: "friday",
      title: "viernes"
    }, {
      id: "saturday",
      title: "sábado"
    }, {
      id: "sunday",
      title: "domingo"
    }]
  };
};
const countries = () => {
  return [{
    id: "spain",
    esCountry: "España",
    enCountry: "Spain",
    prefix: "+34",
    countryCode: "ES",
    sepa: true
  }, {
    id: "andorra",
    esCountry: "Andorra",
    enCountry: "Andorra",
    prefix: "+376",
    countryCode: "AD",
    sepa: true
  }, {
    id: "austria",
    esCountry: "Austria",
    enCountry: "Austria",
    prefix: "+43",
    countryCode: "AT",
    sepa: true
  }, {
    id: "belgica",
    esCountry: "Bélgica",
    enCountry: "Belgium",
    prefix: "+32",
    countryCode: "BE",
    sepa: true
  }, {
    id: "dinamarca",
    esCountry: "Dinamarca",
    enCountry: "Denmark",
    prefix: "+45",
    countryCode: "DK",
    sepa: true
  }, {
    id: "finlandia",
    esCountry: "Finlandia",
    enCountry: "Finland",
    prefix: "+358",
    countryCode: "FI",
    sepa: true
  }, {
    id: "france",
    esCountry: "Francia",
    enCountry: "France",
    prefix: "+33",
    countryCode: "FR",
    sepa: true
  }, {
    id: "germany",
    esCountry: "Alemania",
    enCountry: "Germany",
    prefix: "+49",
    countryCode: "DE",
    sepa: true
  }, {
    id: "greece",
    esCountry: "Grecia",
    enCountry: "Greece",
    prefix: "+30",
    countryCode: "GR",
    sepa: true
  }, {
    id: "irlanda",
    esCountry: "Irlanda",
    enCountry: "Ireland",
    prefix: "+353",
    countryCode: "IE",
    sepa: true
  }, {
    id: "italy",
    esCountry: "Italia",
    enCountry: "Italy",
    prefix: "+39",
    countryCode: "IT",
    sepa: true
  }, {
    id: "monaco",
    esCountry: "Mónaco",
    enCountry: "Monaco",
    prefix: "+377",
    countryCode: "MC",
    sepa: true
  }, {
    id: "netherlands",
    esCountry: "Países Bajos",
    enCountry: "Netherlands",
    prefix: "+31",
    countryCode: "NL",
    sepa: true
  }, {
    id: "noruega",
    esCountry: "Noruega",
    enCountry: "Norway",
    prefix: "+47",
    countryCode: "NO",
    sepa: true
  }, {
    id: "portugal",
    esCountry: "Portugal",
    enCountry: "Portugal",
    prefix: "+351",
    countryCode: "PT",
    sepa: true
  }, {
    id: "suecia",
    esCountry: "Suecia",
    enCountry: "Sweden",
    prefix: "+46",
    countryCode: "SE",
    sepa: true
  }, {
    id: "switzerland",
    esCountry: "Suiza",
    enCountry: "Switzerland",
    prefix: "+41",
    countryCode: "CH",
    sepa: false
  }, {
    id: "uk",
    esCountry: "Reino Unido",
    enCountry: "United Kingdom",
    prefix: "+44",
    countryCode: "GB",
    sepa: true
  }, {
    id: "polonia",
    esCountry: "Polonia",
    enCountry: "Poland",
    prefix: "+48",
    countryCode: "PL",
    sepa: true
  }, {
    id: "croacia",
    esCountry: "Croacia",
    enCountry: "Croatia",
    prefix: "+385",
    countryCode: "HR",
    sepa: true
  }, {
    id: "chequia",
    esCountry: "República Checa",
    enCountry: "Czech Republic",
    prefix: "+420",
    countryCode: "CZ",
    sepa: true
  }, {
    id: "rumania",
    esCountry: "Rumanía",
    enCountry: "Romania",
    prefix: "+40",
    countryCode: "RO",
    sepa: true
  }, {
    id: "serbia",
    esCountry: "Serbia",
    enCountry: "Serbia",
    prefix: "+381",
    countryCode: "RS",
    sepa: false
  }, {
    id: "islandia",
    esCountry: "Islandia",
    enCountry: "Iceland",
    prefix: "+354",
    countryCode: "IS",
    sepa: true
  }, {
    id: "bulgaria",
    esCountry: "Bulgaria",
    enCountry: "Bulgaria",
    prefix: "+359",
    countryCode: "BG",
    sepa: true
  }, {
    id: "malta",
    esCountry: "Malta",
    enCountry: "Malta",
    prefix: "+356",
    countryCode: "MT",
    sepa: true
  }, {
    id: "luxemburgo",
    esCountry: "Luxemburgo",
    enCountry: "Luxembourg",
    prefix: "+352",
    countryCode: "LU",
    sepa: true
  }, {
    id: "ucrania",
    esCountry: "Ucrania",
    enCountry: "Ukraine",
    prefix: "+380",
    countryCode: "UA",
    sepa: false
  }, {
    id: "mexico",
    esCountry: "México",
    enCountry: "Mexico",
    prefix: "+52",
    countryCode: "MX",
    sepa: false
  }, {
    id: "costa_rica",
    esCountry: "Costa Rica",
    enCountry: "Costa Rica",
    prefix: "+506",
    countryCode: "CR",
    sepa: false
  }, {
    id: "canada",
    esCountry: "Canadá",
    enCountry: "Canada",
    prefix: "+1",
    countryCode: "CA",
    sepa: false
  }, {
    id: "eeuu",
    esCountry: "Estados Unidos",
    enCountry: "EEUU",
    prefix: "+1",
    countryCode: "US",
    sepa: false
  }, {
    id: "argentina",
    esCountry: "Argentina",
    enCountry: "Argentina",
    prefix: "+54",
    countryCode: "AR",
    sepa: false
  }, {
    id: "bolivia",
    esCountry: "Bolivia",
    enCountry: "Bolivia",
    prefix: "+591",
    countryCode: "BO",
    sepa: false
  }, {
    id: "brazil",
    esCountry: "Brasil",
    enCountry: "Brazil",
    prefix: "+55",
    countryCode: "BR",
    sepa: false
  }, {
    id: "chile",
    esCountry: "Chile",
    enCountry: "Chile",
    prefix: "+56",
    countryCode: "CL",
    sepa: false
  }, {
    id: "colombia",
    esCountry: "Colombia",
    enCountry: "Colombia",
    prefix: "+57",
    countryCode: "CO",
    sepa: false
  }, {
    id: "ecuador",
    esCountry: "Ecuador",
    enCountry: "Ecuador",
    prefix: "+593",
    countryCode: "EC",
    sepa: false
  }, {
    id: "paraguay",
    esCountry: "Paraguay",
    enCountry: "Paraguay",
    prefix: "+595",
    countryCode: "PY",
    sepa: false
  }, {
    id: "peru",
    esCountry: "Perú",
    enCountry: "Peru",
    prefix: "+51",
    countryCode: "PE",
    sepa: false
  }, {
    id: "uruguay",
    esCountry: "Uruguay",
    enCountry: "Uruguay",
    prefix: "+598",
    countryCode: "UY",
    sepa: false
  }, {
    id: "venezuela",
    esCountry: "Venezuela",
    enCountry: "Venezuela",
    prefix: "+58",
    countryCode: "VE",
    sepa: false
  }, {
    id: "guatemala",
    esCountry: "Guatemala",
    enCountry: "Guatemala",
    prefix: "+502",
    countryCode: "GT",
    sepa: false
  }, {
    id: "el_salvador",
    esCountry: "El Salvador",
    enCountry: "El Salvador",
    prefix: "+503",
    countryCode: "SV",
    sepa: false
  }, {
    id: "puerto_rico",
    esCountry: "Puerto Rico",
    enCountry: "Puerto Rico",
    prefix: "+1",
    countryCode: "PR",
    sepa: false
  }, {
    id: "cuba",
    esCountry: "Cuba",
    enCountry: "Cuba",
    prefix: "+53",
    countryCode: "CU",
    sepa: false
  }, {
    id: "honduras",
    esCountry: "Honduras",
    enCountry: "Honduras",
    prefix: "+504",
    countryCode: "HN",
    sepa: false
  }, {
    id: "nicaragua",
    esCountry: "Nicaragua",
    enCountry: "Nicaragua",
    prefix: "+505",
    countryCode: "NI",
    sepa: false
  }, {
    id: "panama",
    esCountry: "Panamá",
    enCountry: "Panama",
    prefix: "+507",
    countryCode: "PA",
    sepa: false
  }, {
    id: "republica_dominicana",
    esCountry: "República Dominicana",
    enCountry: "Dominican Republic",
    prefix: "+1829",
    countryCode: "DO",
    sepa: false
  }, {
    id: "eau",
    esCountry: "Emiratos Árabes Unidos",
    enCountry: "United Arab Emirates",
    prefix: "+971",
    countryCode: "AE",
    sepa: false
  }];
};
const cities = () => {
  return [{
    id: "A Coruña",
    title: "A Coruña"
  }, {
    id: "Araba",
    title: "Álava"
  }, {
    id: "Albacete",
    title: "Albacete"
  }, {
    id: "Alicante",
    title: "Alicante"
  }, {
    id: "Almería",
    title: "Almería"
  }, {
    id: "Asturias",
    title: "Asturias"
  }, {
    id: "Ávila",
    title: "Ávila"
  }, {
    id: "Badajoz",
    title: "Badajoz"
  }, {
    id: "Illes Balears",
    title: "Illes Balears"
  }, {
    id: "Barcelona",
    title: "Barcelona"
  }, {
    id: "Burgos",
    title: "Burgos"
  }, {
    id: "Cáceres",
    title: "Cáceres"
  }, {
    id: "Cádiz",
    title: "Cádiz"
  }, {
    id: "Cantabria",
    title: "Cantabria"
  }, {
    id: "Castelló",
    title: "Castelló"
  }, {
    id: "Ceuta",
    title: "Ceuta"
  }, {
    id: "Ciudad Real",
    title: "Ciudad Real"
  }, {
    id: "Córdoba",
    title: "Córdoba"
  }, {
    id: "Cuenca",
    title: "Cuenca"
  }, {
    id: "Girona",
    title: "Girona"
  }, {
    id: "Granada",
    title: "Granada"
  }, {
    id: "Guadalajara",
    title: "Guadalajara"
  }, {
    id: "Gipuzkoa",
    title: "Gipuzkoa"
  }, {
    id: "Huelva",
    title: "Huelva"
  }, {
    id: "Huesca",
    title: "Huesca"
  }, {
    id: "Jaén",
    title: "Jaén"
  }, {
    id: "La Rioja",
    title: "La Rioja"
  }, {
    id: "León",
    title: "León"
  }, {
    id: "Lleida",
    title: "Lleida"
  }, {
    id: "Lugo",
    title: "Lugo"
  }, {
    id: "Madrid",
    title: "Madrid"
  }, {
    id: "Málaga",
    title: "Málaga"
  }, {
    id: "Melilla",
    title: "Melilla"
  }, {
    id: "Murcia",
    title: "Murcia"
  }, {
    id: "Navarra",
    title: "Navarra"
  }, {
    id: "Ourense",
    title: "Ourense"
  }, {
    id: "Palencia",
    title: "Palencia"
  }, {
    id: "Pontevedra",
    title: "Pontevedra"
  }, {
    id: "Salamanca",
    title: "Salamanca"
  }, {
    id: "Segovia",
    title: "Segovia"
  }, {
    id: "Sevilla",
    title: "Sevilla"
  }, {
    id: "Soria",
    title: "Soria"
  }, {
    id: "Tarragona",
    title: "Tarragona"
  }, {
    id: "Teruel",
    title: "Teruel"
  }, {
    id: "Toledo",
    title: "Toledo"
  }, {
    id: "Valencia",
    title: "Valencia"
  }, {
    id: "Valladolid",
    title: "Valladolid"
  }, {
    id: "Bizkaia",
    title: "Bizkaia"
  }, {
    id: "Zamora",
    title: "Zamora"
  }, {
    id: "Zaragoza",
    title: "Zaragoza"
  }, {
    id: "Lanzarote",
    title: "Lanzarote"
  }, {
    id: "Las Palmas",
    title: "Las Palmas"
  }, {
    id: "Santa Cruz de Tenerife",
    title: "Santa Cruz de Tenerife"
  }].sort(dynamicSort("title"));
};
function languages() {
  return [{
    id: "spanish",
    title: "Español",
    en: "Spanish"
  }, {
    id: "english",
    title: "Inglés",
    en: "English"
  }, {
    id: "french",
    title: "Francés",
    en: "French"
  }, {
    id: "german",
    title: "Alemán",
    en: "German"
  }, {
    id: "portugues",
    title: "Portugués",
    en: "Portuguese"
  }, {
    id: "italian",
    title: "Italiano",
    en: "Italian"
  }, {
    id: "catalan",
    title: "Catalán",
    en: "Catalan"
  }, {
    id: "basque",
    title: "Euskera",
    en: "Basque"
  }, {
    id: "galician",
    title: "Gallego",
    en: "Galician"
  }, {
    id: "russian",
    title: "Ruso",
    en: "Russian"
  }, {
    id: "arabic/dariya",
    title: "Árabe/Dariya",
    en: "Arabic/Dariya"
  }, {
    id: "chinese",
    title: "Chino",
    en: "Chinese"
  }, {
    id: "japanese",
    title: "Japonés",
    en: "Japanese"
  }, {
    id: "other",
    title: "Otro",
    en: "Other"
  }].sort(dynamicSort("title"));
}
function findLanguages(idLanguage, locale) {
  const foundLanguage = languages().find(item => item.id === idLanguage);
  if (foundLanguage) {
    return locale === "en" ? foundLanguage.en : foundLanguage.title;
  } else {
    return "";
  }
}
const country = () => {
  return [{
    title: "Afganistán",
    id: "AF"
  }, {
    title: "Islas Åland",
    id: "AX"
  }, {
    title: "Albania",
    id: "AL"
  }, {
    title: "Argelia",
    id: "DZ"
  }, {
    title: "Samoa Americana",
    id: "AS"
  }, {
    title: "Andorra",
    id: "AD"
  }, {
    title: "Angola",
    id: "AO"
  }, {
    title: "Anguila",
    id: "AI"
  }, {
    title: "Antártida",
    id: "AQ"
  }, {
    title: "Antigua y Barbuda",
    id: "AG"
  }, {
    title: "Argentina",
    id: "AR"
  }, {
    title: "Armenia",
    id: "AM"
  }, {
    title: "Aruba",
    id: "AW"
  }, {
    title: "Australia",
    id: "AU"
  }, {
    title: "Austria",
    id: "AT"
  }, {
    title: "Azerbaiyán",
    id: "AZ"
  }, {
    title: "Baréin",
    id: "BH"
  }, {
    title: "Bahamas",
    id: "BS"
  }, {
    title: "Bangladesh",
    id: "BD"
  }, {
    title: "Barbados",
    id: "BB"
  }, {
    title: "Bielorrusia",
    id: "BY"
  }, {
    title: "Bélgica",
    id: "BE"
  }, {
    title: "Belice",
    id: "BZ"
  }, {
    title: "Benin",
    id: "BJ"
  }, {
    title: "Bermudas",
    id: "BM"
  }, {
    title: "Bután",
    id: "BT"
  }, {
    title: "Bolivia",
    id: "BO"
  }, {
    title: "Bonaire, Sint Eustatius and Saba",
    id: "BQ"
  }, {
    title: "Bosnia y Herzegovina",
    id: "BA"
  }, {
    title: "Botswana",
    id: "BW"
  }, {
    title: "Isla Bouvet",
    id: "BV"
  }, {
    title: "Brasil",
    id: "BR"
  }, {
    title: "Territorio Británico del Océano Índico",
    id: "IO"
  }, {
    title: "Brunei Darussalam",
    id: "BN"
  }, {
    title: "Bulgaria",
    id: "BG"
  }, {
    title: "Burkina Faso",
    id: "BF"
  }, {
    title: "Burundi",
    id: "BI"
  }, {
    title: "Camboya",
    id: "KH"
  }, {
    title: "Camerún",
    id: "CM"
  }, {
    title: "Canadá",
    id: "CA"
  }, {
    title: "Cabo Verde",
    id: "CV"
  }, {
    title: "Islas Caimán",
    id: "KY"
  }, {
    title: "República Centroafricana",
    id: "CF"
  }, {
    title: "Chad",
    id: "TD"
  }, {
    title: "Chile",
    id: "CL"
  }, {
    title: "China",
    id: "CN"
  }, {
    title: "Isla de Navidad",
    id: "CX"
  }, {
    title: "Islas Cocos (Keeling)",
    id: "CC"
  }, {
    title: "Colombia",
    id: "CO"
  }, {
    title: "Comoras",
    id: "KM"
  }, {
    title: "Congo",
    id: "CG"
  }, {
    title: "Congo, República Democrática del",
    id: "CD"
  }, {
    title: "Islas Cook",
    id: "CK"
  }, {
    title: "Costa Rica",
    id: "CR"
  }, {
    title: "Côte d'Ivoire",
    id: "CI"
  }, {
    title: "Croacia",
    id: "HR"
  }, {
    title: "Cuba",
    id: "CU"
  }, {
    title: "Curaçao",
    id: "CW"
  }, {
    title: "Chipre",
    id: "CY"
  }, {
    title: "República Checa",
    id: "CZ"
  }, {
    title: "Dinamarca",
    id: "DK"
  }, {
    title: "Djibouti",
    id: "DJ"
  }, {
    title: "Dominica",
    id: "DM"
  }, {
    title: "República Dominicana",
    id: "DO"
  }, {
    title: "Ecuador",
    id: "EC"
  }, {
    title: "Egipto",
    id: "EG"
  }, {
    title: "El Salvador",
    id: "SV"
  }, {
    title: "Guinea Ecuatorial",
    id: "GQ"
  }, {
    title: "Eritrea",
    id: "ER"
  }, {
    title: "Estonia",
    id: "EE"
  }, {
    title: "Etiopía",
    id: "ET"
  }, {
    title: "Islas Malvinas (Falkland Islands)",
    id: "FK"
  }, {
    title: "Islas Feroe",
    id: "FO"
  }, {
    title: "Fiji",
    id: "FJ"
  }, {
    title: "Finlandia",
    id: "FI"
  }, {
    title: "Francia",
    id: "FR"
  }, {
    title: "Guayana Francesa",
    id: "GF"
  }, {
    title: "Polinesia francesa",
    id: "PF"
  }, {
    title: "Territorios Australes Franceses",
    id: "TF"
  }, {
    title: "Gabón",
    id: "GA"
  }, {
    title: "Gambia",
    id: "GM"
  }, {
    title: "Georgia",
    id: "GE"
  }, {
    title: "Alemania",
    id: "DE"
  }, {
    title: "Ghana",
    id: "GH"
  }, {
    title: "Gibraltar",
    id: "GI"
  }, {
    title: "Grecia",
    id: "GR"
  }, {
    title: "Groenlandia",
    id: "GL"
  }, {
    title: "Granada",
    id: "GD"
  }, {
    title: "Guadalupe",
    id: "GP"
  }, {
    title: "Guam",
    id: "GU"
  }, {
    title: "Guatemala",
    id: "GT"
  }, {
    title: "Guernsey",
    id: "GG"
  }, {
    title: "Guinea",
    id: "GN"
  }, {
    title: "Guinea-Bissau",
    id: "GW"
  }, {
    title: "Guyana",
    id: "GY"
  }, {
    title: "Haití",
    id: "HT"
  }, {
    title: "Islas Heard y McDonald",
    id: "HM"
  }, {
    title: "Santa Sede (Estado de la Ciudad del Vaticano)",
    id: "VA"
  }, {
    title: "Honduras",
    id: "HN"
  }, {
    title: "Hong Kong",
    id: "HK"
  }, {
    title: "Hungría",
    id: "HU"
  }, {
    title: "Islandia",
    id: "IS"
  }, {
    title: "India",
    id: "IN"
  }, {
    title: "Indonesia",
    id: "ID"
  }, {
    title: "Irán, República Islámica del",
    id: "IR"
  }, {
    title: "Iraq",
    id: "IQ"
  }, {
    title: "Irlanda",
    id: "IE"
  }, {
    title: "Isla de Man",
    id: "IM"
  }, {
    title: "Israel",
    id: "IL"
  }, {
    title: "Italia",
    id: "IT"
  }, {
    title: "Jamaica",
    id: "JM"
  }, {
    title: "Japón",
    id: "JP"
  }, {
    title: "Jersey",
    id: "JE"
  }, {
    title: "Jordan",
    id: "JO"
  }, {
    title: "Kazajstán",
    id: "KZ"
  }, {
    title: "Kenia",
    id: "KE"
  }, {
    title: "Kiribati",
    id: "KI"
  }, {
    title: "Corea, República Popular Democrática de",
    id: "KP"
  }, {
    title: "República de Corea",
    id: "KR"
  }, {
    title: "Kuwait",
    id: "KW"
  }, {
    title: "Kirguistán",
    id: "KG"
  }, {
    title: "República Democrática Popular Lao",
    id: "LA"
  }, {
    title: "Letonia",
    id: "LV"
  }, {
    title: "Líbano",
    id: "LB"
  }, {
    title: "Lesotho",
    id: "LS"
  }, {
    title: "Liberia",
    id: "LR"
  }, {
    title: "Libia",
    id: "LY"
  }, {
    title: "Liechtenstein",
    id: "LI"
  }, {
    title: "Lituania",
    id: "LT"
  }, {
    title: "Luxemburgo",
    id: "LU"
  }, {
    title: "Macao",
    id: "MO"
  }, {
    title: "Macedonia, la ex República Yugoslava de",
    id: "MK"
  }, {
    title: "Madagascar",
    id: "MG"
  }, {
    title: "Malawi",
    id: "MW"
  }, {
    title: "Malasia",
    id: "MY"
  }, {
    title: "Maldivas",
    id: "MV"
  }, {
    title: "Mali",
    id: "ML"
  }, {
    title: "Malta",
    id: "MT"
  }, {
    title: "Islas Marshall",
    id: "MH"
  }, {
    title: "Martinica",
    id: "MQ"
  }, {
    title: "Mauritania",
    id: "MR"
  }, {
    title: "Mauricio",
    id: "MU"
  }, {
    title: "Mayotte",
    id: "YT"
  }, {
    title: "México",
    id: "MX"
  }, {
    title: "Micronesia, Estados Federados de",
    id: "FM"
  }, {
    title: "Moldavia, República de",
    id: "MD"
  }, {
    title: "Mónaco",
    id: "MC"
  }, {
    title: "Mongolia",
    id: "MN"
  }, {
    title: "Montenegro",
    id: "ME"
  }, {
    title: "Montserrat",
    id: "MS"
  }, {
    title: "Marruecos",
    id: "MA"
  }, {
    title: "Mozambique",
    id: "MZ"
  }, {
    title: "Myanmar",
    id: "MM"
  }, {
    title: "Namibia",
    id: "NA"
  }, {
    title: "Nauru",
    id: "NR"
  }, {
    title: "Nepal",
    id: "NP"
  }, {
    title: "Países Bajos",
    id: "NL"
  }, {
    title: "Nueva Caledonia",
    id: "NC"
  }, {
    title: "Nueva Zelanda",
    id: "NZ"
  }, {
    title: "Nicaragua",
    id: "NI"
  }, {
    title: "Níger",
    id: "NE"
  }, {
    title: "Nigeria",
    id: "NG"
  }, {
    title: "Niue",
    id: "NU"
  }, {
    title: "Isla Norfolk",
    id: "NF"
  }, {
    title: "Islas Marianas del Norte",
    id: "MP"
  }, {
    title: "Noruega",
    id: "NO"
  }, {
    title: "Omán",
    id: "OM"
  }, {
    title: "Pakistán",
    id: "PK"
  }, {
    title: "Palau",
    id: "PW"
  }, {
    title: "Palestina, Estado de",
    id: "PS"
  }, {
    title: "Panamá",
    id: "PA"
  }, {
    title: "Papua Nueva Guinea",
    id: "PG"
  }, {
    title: "Paraguay",
    id: "PY"
  }, {
    title: "Perú",
    id: "PE"
  }, {
    title: "Filipinas",
    id: "PH"
  }, {
    title: "Pitcairn",
    id: "PN"
  }, {
    title: "Polonia",
    id: "PL"
  }, {
    title: "Portugal",
    id: "PT"
  }, {
    title: "Puerto Rico",
    id: "PR"
  }, {
    title: "Qatar",
    id: "QA"
  }, {
    title: "Reunión",
    id: "RE"
  }, {
    title: "Rumania",
    id: "RO"
  }, {
    title: "Federación de Rusia",
    id: "RU"
  }, {
    title: "Rwanda",
    id: "RW"
  }, {
    title: "Saint Barthélemy",
    id: "BL"
  }, {
    title: "Santa Elena, Ascensión y Tristán da Cunha",
    id: "SH"
  }, {
    title: "Saint Kitts y Nevis",
    id: "KN"
  }, {
    title: "Santa Lucía",
    id: "LC"
  }, {
    title: "San Martín (parte francesa)",
    id: "MF"
  }, {
    title: "San Pedro y Miquelón",
    id: "PM"
  }, {
    title: "San Vicente y las Granadinas",
    id: "VC"
  }, {
    title: "Samoa",
    id: "WS"
  }, {
    title: "San Marino",
    id: "SM"
  }, {
    title: "Santo Tomé y Príncipe",
    id: "ST"
  }, {
    title: "Arabia Saudita",
    id: "SA"
  }, {
    title: "Senegal",
    id: "SN"
  }, {
    title: "Serbia",
    id: "RS"
  }, {
    title: "Seychelles",
    id: "SC"
  }, {
    title: "Sierra Leona",
    id: "SL"
  }, {
    title: "Singapur",
    id: "SG"
  }, {
    title: "Sint Maarten (parte holandesa)",
    id: "SX"
  }, {
    title: "Eslovaquia",
    id: "SK"
  }, {
    title: "Eslovenia",
    id: "SI"
  }, {
    title: "Islas Salomón",
    id: "SB"
  }, {
    title: "Somalia",
    id: "SO"
  }, {
    title: "Sudáfrica",
    id: "ZA"
  }, {
    title: "Islas Georgias del Sur y Sandwich del Sur",
    id: "GS"
  }, {
    title: "Sudán del Sur",
    id: "SS"
  }, {
    title: "España",
    id: "ES"
  }, {
    title: "Sri Lanka",
    id: "LK"
  }, {
    title: "Sudán",
    id: "SD"
  }, {
    title: "Surinam",
    id: "SR"
  }, {
    title: "Svalbard y Jan Mayen",
    id: "SJ"
  }, {
    title: "Swazilandia",
    id: "SZ"
  }, {
    title: "Suecia",
    id: "SE"
  }, {
    title: "Suiza",
    id: "CH"
  }, {
    title: "República Árabe Siria",
    id: "SY"
  }, {
    title: "Taiwán, provincia de China",
    id: "TW"
  }, {
    title: "Tayikistán",
    id: "TJ"
  }, {
    title: "Tanzania, República Unida de",
    id: "TZ"
  }, {
    title: "Tailandia",
    id: "TH"
  }, {
    title: "Timor-Leste",
    id: "TL"
  }, {
    title: "Togo",
    id: "TG"
  }, {
    title: "Tokelau",
    id: "TK"
  }, {
    title: "Tonga",
    id: "TO"
  }, {
    title: "Trinidad y Tobago",
    id: "TT"
  }, {
    title: "Tunisia",
    id: "TN"
  }, {
    title: "Turquía",
    id: "TR"
  }, {
    title: "Turkmenistán",
    id: "TM"
  }, {
    title: "Islas Turcas y Caicos",
    id: "TC"
  }, {
    title: "Tuvalu",
    id: "TV"
  }, {
    title: "Uganda",
    id: "UG"
  }, {
    title: "Ucrania",
    id: "UA"
  }, {
    title: "Emiratos Árabes Unidos",
    id: "AE"
  }, {
    title: "Reino Unido",
    id: "GB"
  }, {
    title: "Estados Unidos",
    id: "EE. UU."
  }, {
    title: "Islas menores alejadas de los Estados Unidos",
    id: "UM"
  }, {
    title: "Uruguay",
    id: "UY"
  }, {
    title: "Uzbekistán",
    id: "UZ"
  }, {
    title: "Vanuatu",
    id: "VU"
  }, {
    title: "Venezuela, República Bolivariana de",
    id: "VE"
  }, {
    title: "Vietnam",
    id: "VN"
  }, {
    title: "Islas Vírgenes, británico",
    id: "VG"
  }, {
    title: "Islas Vírgenes, EE. UU.",
    id: "VI"
  }, {
    title: "Wallis y Futuna",
    id: "WF"
  }, {
    title: "Western Sahara",
    id: "EH"
  }, {
    title: "Yemen",
    id: "YE"
  }, {
    title: "Zambia",
    id: "ZM"
  }, {
    title: "Zimbabwe",
    id: "W"
  }].sort(dynamicSort("title"));
};
const state = () => {
  return [{
    id: "inRegister",
    title: "En registro",
    title_en: "In register",
    grandpa: false,
    volunteer: true,
    dash: false
  }, {
    id: "registered",
    title: "Registrado",
    title_en: "Registered",
    grandpa: true,
    volunteer: true,
    dash: false
  }, {
    id: "training",
    title: "Formación en proceso",
    title_en: "Training in progress",
    grandpa: false,
    volunteer: true,
    dash: false
  }, {
    id: "waiting",
    title: "Pendiente de match",
    title_en: "Pending match",
    grandpa: true,
    volunteer: true,
    dash: true
  }, {
    id: "match",
    title: "Match",
    title_en: "Match",
    grandpa: true,
    volunteer: true,
    dash: true
  }, {
    id: "exVolunteer",
    title: "Ex-voluntario",
    title_en: "Ex-volunteer",
    grandpa: false,
    volunteer: true,
    dash: false
  }, {
    id: "shutdown",
    title: "Baja",
    title_en: "Shutdown",
    grandpa: true,
    volunteer: false,
    dash: true
  }, {
    id: "paused",
    title: "Pausa",
    title_en: "Paused",
    grandpa: true,
    volunteer: false,
    dash: false
  }, {
    id: "banned",
    title: "Bloqueado",
    title_en: "Banned",
    grandpa: false,
    volunteer: true,
    dash: true
  }];
};
function findStateById(id) {
  const states = state();
  return states.find(item => item.id === id) || null;
}
const gender = () => {
  return [{
    id: "male",
    title: "Hombre"
  }, {
    id: "female",
    title: "Mujer"
  }, {
    id: "other",
    title: "Otro"
  }];
};
const volunteering = () => {
  return [{
    id: "online",
    title: "Online"
  }, {
    id: "offline",
    title: "Presencial"
  }];
};
const adminTaskType = () => {
  return {
    support: [{
      id: "needMatch",
      title: "💘 Match pendiente",
      priority: "high"
    }, {
      id: "badReview",
      title: "👎🏼 Valoración negativa",
      priority: "high"
    }, {
      id: "welcome",
      title: "🆕 Bienvenida socio",
      priority: "high"
    }, {
      id: "outLead",
      title: "❌ Donación cancelada",
      priority: "high"
    }, {
      id: "paymentFailed",
      title: "⚠️ Fallo de pago por falta de fondos",
      priority: "high"
    }, {
      id: "matchCanceled",
      title: "📞 Aviso baja",
      priority: "medium"
    }, {
      id: "idleCallDone",
      title: "💔 Inactividad",
      priority: "low"
    }],
    sales: [{
      id: "welcome",
      title: "🆕 Bienvenida socio",
      priority: "high"
    }, {
      id: "outLead",
      title: "❌ Donación cancelada",
      priority: "high"
    }, {
      id: "paymentFailed",
      title: "⚠️ Fallo de pago por falta de fondos",
      priority: "high"
    }]
  };
};
const adminTaskTeam = () => {
  return [{
    id: "sales",
    title: "Ventas"
  }, {
    id: "support",
    title: "Story Builders"
  }, {
    id: "residence",
    title: "Residencias"
  }];
};
const adminTaskState = () => {
  return [{
    id: "pending",
    title: "Pendiente",
    color: "#0000008F",
    backgroundColor: "#F2F2F2"
  }, {
    id: "inProgress",
    title: "En proceso",
    color: "#FF8854",
    backgroundColor: "#FFF6E5"
  }, {
    id: "done",
    title: "Resuelto",
    color: "#448B6D",
    backgroundColor: "#E4F8EE"
  }, {
    id: "canceled",
    title: "No resuelto",
    color: "#E02D2D",
    backgroundColor: "#FFE5E5"
  }];
};
const adminTaskPriority = () => {
  return [{
    id: "high",
    title: "Alta",
    icon: "ChevronsUp",
    color: "#E02D2D"
  }, {
    id: "medium",
    title: "Media",
    icon: "ChevronsUpDown",
    color: "#FF773D"
  }, {
    id: "low",
    title: "Baja",
    icon: "ChevronsDown",
    color: "#008FF5"
  }];
};
const letterTips = () => {
  return [{
    title: "Preséntate brevemente, desde dónde escribes, cuántos años tienes, qué te gusta...",
    title_en: "Introduce yourself briefly, where you write from, how old you are, what are your hobbies..."
  }, {
    title: "Qué tal si le cuentas una anécdota divertida para que te conozca un poco mejor y le saques una sonrisa.",
    title_en: "How about telling a funny anecdote so he gets to know you a little better and makes him smile."
  }, {
    title: "Fíjate en sus aficiones y si compartís alguna céntrate en ella.",
    title_en: "Look at their hobbies and if you share any, focus on them."
  }, {
    title: "Deséale lo mejor para el próximo año. Escríbele un mensaje de cariño y de ánimo.",
    title_en: "Wish him/her the best for the coming year. Write a message of love and encouragement."
  }, {
    title: "Recuérdale lo importante que es y exprésale gratitud porque han construido un mundo mejor para  nosotros.",
    title_en: "Remind them how important they are and express gratitude for having built a better world for us."
  }, {
    title: "Cuéntale una historia que tenga que ver con él, con su ciudad, con sus aficiones...",
    title_en: "Tell him a story that has to do with him, with his city, with his hobbies..."
  }, {
    title: "¡Abre tu corazón! Cuéntale los proyectos que tienes para el año que viene.",
    title_en: "Open your heart! Tell him/her what you have planned for next year."
  }, {
    title: `Termina con un mensaje cariñoso y afectuoso, como “te deseo lo mejor” o “cuídate”.`,
    title_en: `End with a warm and loving message, such as “I wish you the best” or “take care of yourself.”`
  }];
};
exports.default = {
  hobbies,
  findHobbies,
  schedule,
  countries,
  cities,
  languages,
  findLanguages,
  country,
  dynamicSort,
  state,
  findStateById,
  gender,
  volunteering,
  adminTaskType,
  adminTaskTeam,
  adminTaskState,
  adminTaskPriority,
  letterTips
};